import type { MerchantRecommendedCreator } from "@/api/recommendations";
import { downloadCSV } from "@/utils/download-csv";

export const downloadRecommendationsCSV = (
  rows: MerchantRecommendedCreator[],
  filenameBase: string,
  cohortNameById: Map<string, string> | null,
) => {
  const cohortColumn = cohortNameById ? (["cohort"] as const) : [];
  const cohortHeader = cohortNameById ? ["Cohort"] : [];

  downloadCSV(
    rows.map((r) => ({
      ...r,
      cohort: r.cohortId ? (cohortNameById?.get(r.cohortId) ?? "") : "",
      topGender: r.topGender ? `${r.topGender.gender} (${r.topGender.percentage}%)` : "",
      topAgeRange: r.topAgeRange ? `${r.topAgeRange.range} (${r.topAgeRange.percentage}%)` : "",
    })),
    filenameBase,
    [
      "tiktokCreatorOpenId",
      "nickname",
      "username",
      ...cohortColumn,
      "matchQualityScore",
      "gmvAmount",
      "topGender",
      "topAgeRange",
      "videoCount",
      "followerCount",
    ],
    [
      "Creator ID",
      "Nickname",
      "Username",
      ...cohortHeader,
      "Match Quality",
      "GMV",
      "Gender Demo",
      "Main Age Demo",
      "Videos",
      "Followers",
    ],
  );
};
